import SweetAlert from "react-bootstrap-sweetalert";

export default function ModalExcelRows({ toggle, rows = [] }) {
  return (
    <SweetAlert
      title="Corrija os erros abaixo e reenvie a planilha"
      warning
      confirmButtonText="Ok!"
      confirmBtnBsStyle="success"
      onConfirm={toggle}
      style={{ width: "39.1%" }}
    >
      <div style={{ marginTop: 15 }}>
        {rows.length !== 0 ? (
          rows.map((row, index) => (
            <p key={index}>
              {row.message
                ? `Linha ${row.row}: ${row.message}`
                : `Linha ${row.row}: Preencha os campos: ${row.fields.join(", ")}`}
            </p>
          ))
        ) : (
          <p>Utilize o Modelo correto para fazer a importação da planilha</p>
        )}
      </div>
    </SweetAlert>
  );
}
